import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87775b1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "select" }
const _hoisted_7 = { class: "tag" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_11 = { style: {"font-size":"0.24rem"} }
const _hoisted_12 = { class: "other" }
const _hoisted_13 = { class: "other" }
const _hoisted_14 = { class: "action" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Button, Field, CellGroup, Toast, NavBar, Tabs, Tab, List } from "vant";
import router from "@/router";
import { request } from "@/provide/fetch";
import { debounce } from "@/utils";
import pingpp from "pingpp-js";

export default /*#__PURE__*/_defineComponent({
  name: 'OrderPage',
  setup(__props) {

const tabList = ref([
  {
    name: "全部",
    value: null,
    disabled: false,
  },
  {
    name: "待付款",
    value: 0,
    disabled: false,
  },
  {
    name: "处理中",
    value: 1,
    disabled: false,
  },
  {
    name: "已完成",
    value: 2,
    disabled: false,
  },
]);
const activeTab = ref(null);
const loading = ref(false);
const finished = ref(false);
const dataList = ref([]);
const pageParams = reactive({
  pageIndex: 0,
  pageSize: 10,
});
const onLoad = () => {
  loading.value = true;
  debounce(handlegetPage(), 300);
};
//
const handlegetPage = async () => {
  pageParams.pageIndex++;
  const res = await request({
    url: "/order/page",
    method: "POST",
    data: {
      searchOption: {
        status: tabList.value[activeTab.value].value,
      },
      pageParam: pageParams,
    },
  }).catch(() => {
    Toast("网络错误，请稍后重试");
  });
  loading.value = false;
  if (res.code === 200) {
    if (pageParams.pageIndex === 1) {
      dataList.value = [];
    }
    dataList.value = dataList.value.concat(res.data.records);
    finished.value =
      res.data.total <= pageParams.pageIndex * pageParams.pageSize;
    // addressList.value = res.data.records;
  } else {
    Toast(res.message);
    dataList.value = [];
  }
};
const handleTabChange = () => {
  pageParams.pageIndex = 0;
  dataList.value = [];
  onLoad();
};
const userIP = ref("");
onMounted(async () => {
  const res = await fetch(
    "https://api.ipdatacloud.com/v2/query?key=c8c66dfe141411ef81f700163e167ffb"
  );
  const data = await res.json();
  if (data.code === 500) {
    handleV6IP();
  } else {
    userIP.value = data.data.location.ip;
  }
});
const handleV6IP = async () => {
  const resp = await fetch(
    "https://api.ipdatacloud.com/v2/query?key=ff3ef544425c11ef98e000163e167ffb"
  );
  const data = await resp.json();
  userIP.value = data.data.location.ip;
};
const handlePay = (item: any) => {
  //
  const data = {
    orderId: item.orderId,
    payType: item.payType,
    // payType: 2,
    price: item.payPrice,
    clientIp: userIP.value,
  };
  request({
    url: "/card-order/pay",
    method: "POST",
    data: data,
  }).then((res) => {
    //
    pingpp.createPayment(res.data, (result, err) => {
      if (result == "success") {
        console.log("success");
      } else {
        console.log("失败");
        router.push({
          path: "/OrderPage",
        });
      }
    });
  });
};
const handleDelete = (item: any) => {
  request({
    url: `/order/delete/${item.orderId}`,
    method: "POST",
  })
    .then((res) => {
      if (res.code === 200) {
        Toast("删除成功");
        pageParams.pageIndex = 0;
        dataList.value = [];
        onLoad();
      } else {
        Toast(res.message);
      }
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "订单",
      style: {"height":"0.92rem"}
    }),
    _createVNode(_unref(Tabs), {
      active: activeTab.value,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      color: "#386bf6",
      onClick: handleTabChange,
      style: {"height":"0.88rem"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(Tab), {
            title: item.name,
            key: index
          }, null, 8, ["title"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(List), {
        loading: loading.value,
        "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
        finished: finished.value,
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "order-card",
              key: index,
              onClick: ($event: any) => (_unref(router).push('/orderDetails/' + item.orderId))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["status", 
              item.processStatus == 0
                ? 'obligation'
                : item.processStatus == 1
                ? 'processing'
                : 'done'
            ])
              }, _toDisplayString(item.processStatus == 0
                ? "待付款"
                : item.processStatus == 1
                ? "处理中"
                : "已完成"), 3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.productName), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.flowLevel) + " × " + _toDisplayString(item.selectDays), 1),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.productSellPoints, (tagItem) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: tagItem,
                        class: "tagItem"
                      }, _toDisplayString(tagItem), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(_toDisplayString(item.payPrice / 100), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, "共" + _toDisplayString(item.buyCount) + "件", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, "订单编号：" + _toDisplayString(item.orderNo), 1),
              _createElementVNode("div", _hoisted_13, "订单时间：" + _toDisplayString(item.createTime), 1),
              _createElementVNode("div", _hoisted_14, [
                (item.processStatus == 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _withModifiers(($event: any) => (handlePay(item)), ["stop"]),
                      class: "btn pay"
                    }, "去支付", 8, _hoisted_15))
                  : _createCommentVNode("", true),
                (item.processStatus == 2)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: _withModifiers(($event: any) => (_unref(router).push('/hotGoodsDetails/' + item.productId)), ["stop"]),
                      class: "btn submit"
                    }, "再次购买", 8, _hoisted_16))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading", "finished"])
    ])
  ]))
}
}

})